export { useAuthStore } from './auth.js';
export { useKeycloakStore } from './keycloak.js';
export { useAccountStore } from './account.js';
export { useApimoneyStore } from './apimoney.js';
export { usePollStore } from './poll.js';
export { usePostStore } from './post.js';
export { useMessageStore } from './message.js';
export { useStripeStore } from './stripe.js';
export { useNotificationStore } from './notification.js';
export { usePaymentLinkStore } from './payment_link.js';
export { useInvitationStore } from './invitation.js';
export { useLocationStore } from './location.js';
export { useShopStore } from './shop.js';
export { useShoppingCartStore } from './shoppingCart.js';
export { usePaymentStore } from './payment.js';
export { useDeliveryStore } from './delivery.js';
export { useGroupsStore } from './group.js';
export { useCampaignsStore } from './campaign.js';
export { useAdsStore } from './ads.js';
export { useBillingStore } from './billing.js';
export { useMembersStore } from './members.js';
export { useFeedStore } from './feed.js';
export { useGrowthStore } from './growth.js';
export { useCalendarStore } from './calendar.js';

export function setupPiniaPlugins(pinia, app) {
  pinia.use(({ store }) => {
    store.$lcStorage = app.config.globalProperties.$lcStorage;
    store.$filtersToDate = app.config.globalProperties.$filtersToDate;
  });
}
